<template>
  <div class="login_content">
    <div class="login_box">
      <div class="nav_box">
        <span class="iconfont icon-fanhui" @click="goHome"></span>
        <span @click="goHome">首页</span>
      </div>
      <div class="title">贵州省建设工程招标投标协会从业人员登录入口</div>
      <img class="bg" src="@/assets/images/login/bg6.png" />
      <div class="hh_box">
        <div class="box">
          <div class="input_box">
            <Input
              key="sjh"
              v-model="form.phone"
              class="input"
              placeholder="请输入手机号"
            >
              <span slot="prepend">手机号</span>
            </Input>
            <Input
              key="yzm"
              v-model="form.phoneveriCode"
              class="input"
              placeholder="请输入验证码"
            >
              <span slot="prepend">验证码</span>
              <!-- <img slot="append" :src="txYzm"/> -->
              <span
                slot="append"
                :style="{ 'pointer-events': isDisabled ? 'none' : '' }"
                class="yzm"
                @click="getYzm"
                >{{ sms_code }}</span
              >
            </Input>
            <div class="flex_mm">
              <Checkbox v-model="checked" class="check_box" @on-change="lookPop"
                >我已阅读《隐私条款》
              </Checkbox>
              <!--              <div class="zhmm" @click="rePwd">-->
              <!--                <span class="iconfont icon-wangjimima"></span>-->
              <!--                <span>忘记密码</span>-->
              <!--              </div>-->
            </div>
            <Button
              :loading="loading"
              class="btn"
              long
              type="primary"
              @click="submit"
              >登录</Button
            >
          </div>
        </div>
      </div>
      <Modal
        v-model="showModal"
        :closable="false"
        :mask-closable="false"
        ok-text="我已阅读并同意"
        title="隐私条款"
        @on-ok="ok"
      >
        <p class="xy_box" v-html="xyInfo.content"></p>
      </Modal>
    </div>
  </div>
</template>
<script>
import { getStuCode, getLogin, getHyLogin } from "@/api/login";
import { getSingleArticle } from "@/api/home/guild";
export default {
  data() {
    return {
      showModal: false,
      checked: false,
      form: {
        phone: "",
        phoneveriCode: "",
      },
      loading: false,
      xyInfo: {
        content: "",
      },
      sms_code: "获取验证码", //获取验证码按钮
      currentTime: 59,
      isDisabled: false,
    };
  },
  mounted() {},
  methods: {
    getSingleArticle() {
      getSingleArticle({
        catid: 210,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.xyInfo = res.result;
          this.xyInfo.content = this.xyInfo.content.replace(
            /\<span/gi,
            `<span style="font-size:15px!important" `,
          );
        }
      });
    },
    submit() {
      if (this.form.phone == "") {
        this.$Message.info("手机号不能为空");
        return;
      }
      if (this.form.phoneveriCode == "") {
        this.$Message.info("验证码不能为空");
        return;
      }
      if (!this.checked) {
        this.$Message.info("请勾选同意隐私条款！");
        return;
      }
      this.loading = true;
      getLogin({
        phone: this.form.phone,
        loginName: this.form.loginName,
        phoneveriCode: this.form.phoneveriCode,
      }).then((res) => {
        console.log("getLogin", res);
        this.loading = false;
        if (res.code == 200) {
          this.$Message.success("登录成功！");
          this.$Cookies.set("cyry_token", res.result.token);
          this.$Cookies.set("cyry_user", JSON.stringify(res.result));
          this.showLogin = false;
          this.$router.push("cyry");
          location.reload();
        } else if (res.code == 201) {
          this.$Modal.confirm({
            title: "温馨提示",
            content:
              "尊敬的用户，您还未注册成为从业人员，请您注册后使用相关功能！",
            okText: "前往注册",
            onOk: () => {
              let url = `${this.$ksHost}/#/register?token=${res.result.token}`;
              window.open(url, "_blank");
              // let url =
              // 	`${this.$ksHost}/#/login?type=1&token=${res.result.token}`;
              // window.open(url, '_blank')
            },
          });
        } else if (res.code == 203) {
          //审核未通过
          this.$Modal.confirm({
            title: "温馨提示",
            content: res.message,
            okText: "前往登录查看",
            onOk: () => {
              let url = `${this.$ksHost}/#/exam-home?token=${res.result.token}`;
              window.open(url, "_blank");
              // let url =
              // 	`${this.$ksHost}/#/login?type=1&token=${res.result.token}`;
              // window.open(url, '_blank')
            },
          });
        }
      });
    },
    lookPop() {
      this.showModal = true;
      this.getSingleArticle(); //隐私条款
    },
    ok() {
      this.checked = true;
    },
    goHome() {
      this.$router.push("/");
    },
    rePwd() {
      this.$Modal.info({
        title: "提示",
        content: "请联系协会重置密码，联系电话：0851-86587786",
        onOk: () => {},
      });
    },
    getYzm() {
      // if (this.form.loginName == '') {
      // 	this.$Message.info('姓名不能为空');
      // 	return
      // }
      if (this.form.phone == "") {
        this.$Message.info("手机号不能为空");
        return;
      }
      getStuCode({
        phone: this.form.phone,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.$Message.success("发送成功");
          this.countDown();
          this.isDisabled = true;
        } else {
          this.$Modal.error({
            title: "提示",
            content: res.message,
            onOk: () => {},
          });
          this.isDisabled = false;
        }
      });
    },
    //验证码倒计时
    countDown(options) {
      var that = this;
      var interval = setInterval(function () {
        that.currentTime--;
        if (that.currentTime <= 0) {
          clearInterval(interval);
          that.sms_code = "重新获取";
          that.currentTime = 59;
          that.isDisabled = false;
        } else {
          that.sms_code = that.currentTime + "s";
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.login_content {
  overflow-y: scroll;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.login_box {
  min-width: 1100px;
  overflow: scroll;
  .bg {
    min-width: 1100px;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    // object-fit: cover;
  }
  .title {
    position: absolute;
    color: #ffffff;
    font-size: clamp(1rem, 3vw, 3.3rem);
    right: 120px;
    top: 95px;
    letter-spacing: 3px;
    z-index: 1;
  }
  .nav_box {
    position: absolute;
    padding: 20px 50px;
    font-size: 20px;
    display: flex;
    align-items: center;
    z-index: 9999;
    span {
      cursor: pointer;
    }
    .icon-fanhui {
      font-size: 30px;
      margin-right: 10px;
    }
  }
  .hh_box {
    min-width: 1100px;
    position: absolute;
    top: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .box {
      width: 900px;
      display: flex;
      justify-content: center;

      .input_box {
        width: 450px;
        .input {
          width: 100%;
          margin-bottom: 25px;

          /deep/ .ivu-input-group-append {
            background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
            color: #fff;
            width: 100px;
            cursor: pointer;
            border: none;
            font-size: 15px;
          }

          /deep/ .ivu-input-group-prepend {
            background-color: #d0e8ff;
            width: 165px;
            font-size: 15px;
            text-align-last: justify;
            padding: 0 20px;
            color: #333;
          }
        }

        /deep/ .ivu-input-group .ivu-input,
        .ivu-input-group .ivu-input-inner-container {
          height: 40px;
          font-size: 14px;
        }

        .flex_mm {
          margin-bottom: 20px;
          color: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          .check_box {
            /deep/ .ivu-checkbox-inner {
              margin-right: 5px;
            }
          }
          .zhmm {
            cursor: pointer;
            font-size: 13px;
            display: flex;
            align-items: center;
            .iconfont {
              margin-right: 3px;
            }
          }
          .zhmm:hover {
            // color: #2B4BFA;
          }
        }

        .btn {
          height: 40px;
          font-size: 18px;
          letter-spacing: 30px;
          padding-left: 40px;
          background: #2b4bfa;
          box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.4);
          border: none;
        }
      }
    }
  }
}
.xy_box {
  height: 400px;
  overflow: scroll;
}

/deep/ .ivu-btn-text {
  display: none;
}
</style>
